import React, { useState, useEffect } from 'react';
import Layout from '../core/Layout';
import { isAuthenticated } from '../auth';
import { Link } from 'react-router-dom';
import { getAllOrders, updateOrderStatus } from './apiAdmin';

const AdminDashboard = () => {
    const { user: {_id, name, email, role }, token } = isAuthenticated();
    const [orders, setOrders] = useState([]);
    const [orderStatus, setOrderStatus] = useState({status: '', orderId:''});

    const init = () => {
        getAllOrders(_id, token).then(
            data => {
                setOrders(data.orders); //for some reason returns nested array 
            });
    };
    
    useEffect(() => {
        init();
    },[]);

    const adminLinks = () => {
        return (
            <div className="card mb-12 container-fluid">
                <h4 className="card-header">Admin Links </h4>

                <ul className="list-group">
                    <li className="list-group-item">
                        <Link className="nav-link" to="/create/category">
                            Create Category
                        </Link>
                    </li>
                </ul> 
            </div>
        );  
    };
    
    const clickSubmit = event => {
        event.preventDefault();
        console.log('orderid');
        console.log(orderStatus.orderId);
        updateOrderStatus(_id, orderStatus.orderId, token, orderStatus.status)
            .then(data => console.log(data));
    };
    const handleChange = event  => {
        setOrderStatus(JSON.parse(event.target.value));
    }
    const showOrders = () => {
        return (
            <div className='card mb-12 container-fluid'>
                <h4 className='card-header'> Orders </h4>
                <ul>
                    {orders && orders.map((order,i) => (
                        <li key={i}> 
                            {order._id}
                            <br/>
                            {order.status}
                            <form onSubmit={clickSubmit} >
                                <select
                                    className='form-control'
                                    onChange={handleChange}
                                >
                                    <option> Please select </option>
                                    <option value={JSON.stringify({status:'Processing', orderId: order._id})}> Processing </option>
                                </select>
                                <button className='btn btn-outline-primary'> Submit </button>
                            </form>
                        </li>
                    ))}
                </ul>
            </div>
        );

    };

    return (
        <Layout title='Dashboard' description={`Hello ${name}`} className='container-fluid'>
            <div className='row'>
                <div className='col-12'>
                    {adminLinks()}
                    <br/>
                    {showOrders()}
                </div>
            </div>
        </Layout>
    );
};

export default AdminDashboard;
